import { render, staticRenderFns } from "./navigationCard.vue?vue&type=template&id=8177c9fa&"
import script from "./navigationCard.vue?vue&type=script&lang=js&"
export * from "./navigationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports